import { useState } from "react";
import s from './payouts-table.module.scss'
import useMedia from "use-media";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react/dist/cjs/tabler-icons-react";
import ReactPaginate from "react-paginate";
import { PayoutCard } from '../payout-card/payout-card';
import { usePayouts } from "@entities/profile/api/usePayouts";
import { useAllOrders } from "@entities/schedule/api/useAllOrders";
import { FetchingDiv } from "@shared/ui/fetching-div/fetching-div";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@shared/ui/table/table";

export const PayoutsTable = () => {
	const [page, setPage] = useState(0)
	const { data: payouts, isFetched } = usePayouts({ page: page + 1 });
	const { data: orders } = useAllOrders();

	// Заказы, по которым ещё нет выплат
	const payoutOrderIds = new Set(payouts?.data?.map((p) => p.order_id) ?? []);
	const pendingOrders = (orders ?? []).filter((o) => !payoutOrderIds.has(o.id));
	const isEmpty = !payouts?.total && pendingOrders.length === 0;
		
	const isMobile = useMedia({maxWidth: '768px'})

  return (
		<FetchingDiv className={s.wrapper} isFetching={!isFetched}>
			{!isEmpty ? (
				<div className={s.flex}>
					<Table>
						<TableHeader className={s.mobileHiddenHeader}>
							<TableRow>
								<TableHead>Заказ</TableHead>
								<TableHead>Статус</TableHead>
								<TableHead>Ученик</TableHead>
								<TableHead>Дата</TableHead>
								<TableHead contentClassName={s.amountHead}>Получено</TableHead>
								<TableHead>Чек</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{pendingOrders.map((order) => (
								<PayoutCard key={`order-${order.id}`} order={order} order_id={order.id} isPending {...{ isMobile }} />
							))}
							{payouts?.data?.map((cl) => (
								<PayoutCard key={cl.id} {...cl} {...{ isMobile }} />
							))}
						</TableBody>
					</Table>
					{payouts?.last_page > 1 && (
						<ReactPaginate
							breakLabel="..."
							forcePage={page}
							nextLabel={<IconChevronRight size={12} />}
							onPageChange={(e) => setPage(e.selected)}
							pageRangeDisplayed={5}
							pageCount={Math.ceil((payouts?.total || 0) / (payouts?.per_page || 1))}
							previousLabel={<IconChevronLeft size={12} />}
							className={s.paginator}
							previousClassName={s.prev}
							nextClassName={s.next}
							disabledClassName={s.disabled}
							pageLinkClassName={s.item}
							activeLinkClassName={s.active}
						/>
					)}
				</div>
			) : (
				<div className={s.empty}>Здесь пока ничего нет</div>
			)}
		</FetchingDiv>
  );
};
